import {PwrCnt} from '../model/pwrcnt.model';
import {Injectable} from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';


@Injectable()
export class PricingService {

  monthlyCost = 90;
  kwhPrice = 0.6;
  price_obs: Observable<any>;

  constructor(public af: AngularFireDatabase) {
    this.price_obs = af.object('/kwh_price').valueChanges();
    this.price_obs.subscribe(value => {
        this.kwhPrice = value;
      }
    );
  }

  getkWhPrice_Observable() {
    return this.price_obs;
  }

  getkWhPrice_PLN() {
    return this.kwhPrice;
  }

  setkWhPrice(kWhPrice: number) {
    this.kwhPrice = kWhPrice;
  }


  getMonthlyPowerRequisition_kWh() {
    return this.monthlyCost / this.getkWhPrice_PLN();
  }

  setMonthlyCosts_PLN(monthlyCost: number) {
    this.monthlyCost = monthlyCost;
  }
  getMonthlyCost() {
    return this.monthlyCost;
  }

  getYearlyCost() {
    return 12 * this.monthlyCost;
  }

  // getInstallationCost(forPanels: PwrCnt) {
  //   return forPanels.cnt; // todo: liczyć koszt instalacji
  // }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/pricing.service.ts